<script setup lang="ts">
interface ComparisonRow {
  label: string;
  classicalValue: string;
  dwzValue: string;
}

interface Props {
  header: string;
  classicalLabel: string;
  dwzLabel: string;
  rows: ComparisonRow[];
}

defineProps<Props>();
</script>

<template>
  <div class="bg-bg-page rounded-large">
    <h3 class="text-title-large text-text-primary text-center px-lg pb-sm border-b border-border-light">{{ header }}</h3>
    <div class="px-lg mt-md">
      <div class="flex items-center justify-between px-lg py-sm bg-bg-pill rounded-small">
        <span class="flex-1 text-right text-label-large font-bold text-trad-500">{{ classicalLabel }}</span>
        <span class="flex-1 text-left text-label-large font-bold text-dwz-500">{{ dwzLabel }}</span>
      </div>
    </div>
    <div class="px-lg mt-md flex flex-col gap-xl">
      <div v-for="row in rows" :key="row.label" class="flex flex-col items-stretch">
        <span class="text-label-small text-text-secondary mb-xs">{{ row.label }}</span>
        <div class="w-full px-lg py-sm bg-bg-card border border-border-light rounded-small flex items-center">
          <span class="flex-1 text-right text-body-medium font-bold text-trad-500">{{ row.classicalValue }}</span>
          <span class="w-lg" />
          <span class="flex-1 text-left text-body-medium font-bold text-dwz-500">{{ row.dwzValue }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
